import { format } from 'date-fns';

export const DEFAULT_PATTERN = 'dd.MM.yyyy';
export const ISO_PATTERN = 'yyyy-MM-dd';
export const MONTH_NAME_PATTERN = 'd MMM, yyyy';

export const DEFAULT_PATTERN_WITH_TIME = 'dd.MM.yyyy HH:mm';

export function toISODate(date: Date): string {
  return format(date, ISO_PATTERN).toString().split('T')[0];
}
